import { useTranslation } from "react-i18next";

import { useRequiredContext } from "@lib/utils";
import { Icon } from "@atoms";

import { HaNSearchContext } from "./HaNSearchContext";

export const HaNSearchInput = () => {
  const { t } = useTranslation();
  const { query, setQuery } = useRequiredContext(HaNSearchContext);

  return (
    <div className="relative px-5 py-4">
      <Icon
        aria-hidden
        icon="search"
        color="currentColor"
        className="pointer-events-none absolute left-8 top-1/2 size-4 -translate-y-1/2 text-mapiq-black-400"
      />

      <input
        type="search"
        aria-label={t("hereAndNow:Search")}
        placeholder={t("hereAndNow:Search")}
        value={query}
        className="w-full rounded-lg bg-mapiq-black-50 py-2 pl-9 pr-9 placeholder:text-mapiq-black-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mapiq-black-800* [&::-webkit-search-cancel-button]:hidden"
        onChange={event => setQuery(event.target.value)}
        onKeyDown={event => {
          if (event.key === "Escape") setQuery("");
        }}
      />

      {query && (
        <button
          type="button"
          aria-label={t("hereAndNow:ClearSearch")}
          className="absolute right-7 top-1/2 flex size-6 -translate-y-1/2 items-center justify-center rounded-full text-mapiq-black-500 hover:bg-black/[0.05] focus-visible:outline focus-visible:outline-2 focus-visible:outline-mapiq-black-900"
          onClick={() => setQuery("")}>
          <Icon
            aria-hidden
            icon="close"
            color="currentColor"
            className="size-3"
          />
        </button>
      )}
    </div>
  );
};
